import React, { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client/react';
import { Loader } from '@progress/kendo-react-indicators';
import moment from 'moment/moment';
import { DEFAULT_GRID_TABLE } from '@components-clean/core/api-grid/api-grid.helper';
import { DropDownList } from '@components-clean/core/drop-down-list';
import ChipsGrid from '@pages-clean/dummy-page/pages/chips-grid';
import {
    FormattedStudyDataSet,
    sortDatasetByDatesDesc,
} from '@pages-clean/dummy-page/pages/data-view-config-poc/data-view-config-poc-page';
import ApiGrid from 'views-clean/components/core/api-grid';
import { useLocalState } from '@hooks/index';
import { GET_DATA_REVIEW_TABLES } from '@queries/central-monitoring';
import {
    dataReviewTables,
    dataReviewTables_OpraQueries_dataReviewTablesForStudy_DataReviewTable,
    dataReviewTablesVariables,
} from '@queries/generated/central-monitoring.generated';
import DatasetApi from '@apis/bff-api/central-monitoring/dataset';

const InfiniteScrollGridPage = () => {
    const { state } = useLocalState();
    const studyId = state?.selectedStudy?.id as string;

    const [datasets, setDatasets] = useState<FormattedStudyDataSet[]>([]);
    const [selectedDataset, setSelectedDataset] = useState<FormattedStudyDataSet | null>(null);
    const [selectedDatatable, setSelectedDatatable] =
        useState<dataReviewTables_OpraQueries_dataReviewTablesForStudy_DataReviewTable | null>(null);

    const { data: cm2Datasets, isLoading: isLoadingDatasets } = DatasetApi.useGetAll(studyId);

    const { data: datatablesData, loading: isLoadingDatatables } = useQuery<
        dataReviewTables,
        dataReviewTablesVariables
    >(GET_DATA_REVIEW_TABLES, {
        variables: { studyId: studyId ?? null },
    });

    const datatables = datatablesData?.dataReviewTablesForStudy?.filter((item) => item?.active) ?? [];

    useEffect(() => {
        setSelectedDatatable(datatables[0]);
    }, [datatablesData]);

    useEffect(() => {
        const formattedDatasets = cm2Datasets
            ?.map((x) => ({
                ...x,
                formattedDate: moment(x.dataCutDate, 'YYYY-MM-DD').format('DD-MMM-YYYY'),
            }))
            .sort(sortDatasetByDatesDesc);

        setDatasets(formattedDatasets ?? []);
    }, [cm2Datasets]);

    useEffect(() => {
        if (state?.selectedStudy?.id) {
            setSelectedDataset(null);
            setSelectedDatatable(null);
        }
    }, [state?.selectedStudy?.id]);

    return (
        <>
            <div className="k-d-flex k-gap-2.5 k-mb-4">
                <div>
                    <DropDownList
                        label="Dataset"
                        data-testid="dataset-selector"
                        data={datasets}
                        value={selectedDataset}
                        textField="formattedDate"
                        style={{ width: '400px' }}
                        disabled={isLoadingDatasets}
                        onChange={(e) => setSelectedDataset(e.value as FormattedStudyDataSet)}
                    />
                    {isLoadingDatasets && <Loader />}
                </div>
            </div>
            {!!selectedDataset?.id && !isLoadingDatatables && (
                <ApiGrid
                    title={datatables?.map((x) => ({
                        ...x,
                        id: x?.id as string,
                        label: x?.name,
                    }))}
                    selectedTitle={
                        selectedDatatable && {
                            ...selectedDatatable,
                            id: selectedDatatable.id as string,
                            label: selectedDatatable.name,
                        }
                    }
                    onTitleChange={(e) => {
                        if (e.value)
                            setSelectedDatatable(
                                e.value as dataReviewTables_OpraQueries_dataReviewTablesForStudy_DataReviewTable,
                            );
                    }}
                    testDataId="dummy-grid"
                    maxHeight="calc(100vh - 230px)"
                    table={DEFAULT_GRID_TABLE}
                    gridParams={{
                        grid: 'DataTable',
                        studyRef: studyId,
                        dataset: selectedDataset.id,
                        datatable: selectedDatatable ? (selectedDatatable?.id as string) : '',
                    }}
                />
            )}
            <br />
            <ChipsGrid />
        </>
    );
};

export default InfiniteScrollGridPage;
